import { FEATURES } from '@constants/Text'

// Descritor único (ordem + gating) dos canais de Omnichannel — fonte de verdade
// reusada pelo modal de lead/cliente e pela view /crm/comunicacoes. `feature: null`
// = sempre visível; array = AND. `modalHidden` = só aparece na view de topo.
const COMUNICACOES_CHANNELS = [
  {
    key: 'atendimento',
    modalValue: 'whatsapp',
    label: 'Mensagens',
    routeName: 'crm.atendimento',
    feature: FEATURES.ATENDIMENTO,
    modalHidden: false,
  },
  {
    key: 'email',
    modalValue: 'email',
    label: 'Email',
    routeName: 'crm.emails',
    feature: null,
    modalHidden: false,
  },
  {
    key: 'transcricoes',
    modalValue: 'transcricoes',
    label: 'Transcrições',
    routeName: 'crm.transcricoes',
    feature: FEATURES.TRANSCRICOES,
    modalHidden: false,
  },
  {
    key: 'ligacoes',
    modalValue: null,
    label: 'Ligações',
    routeName: 'crm.ligacoes',
    feature: [FEATURES.CRM, FEATURES.CRM_LIGACOES],
    modalHidden: true,
  },
]

const isChannelVisible = (channel, can) => {
  if (channel.feature == null) return true
  if (Array.isArray(channel.feature)) return channel.feature.every(can)
  return Boolean(can(channel.feature))
}

const visibleChannels = (can) =>
  COMUNICACOES_CHANNELS.filter((channel) => isChannelVisible(channel, can))

// Canais da aba "Omnichannel" do modal: sem Ligações, sem TUDO (o modal prepõe por fora).
export const comunicacoesModalChannels = (can) =>
  visibleChannels(can)
    .filter((channel) => !channel.modalHidden)
    .map((channel) => ({ value: channel.modalValue, label: channel.label }))

// Sub-nav da view /crm/comunicacoes (inclui Ligações, sem TUDO) — formato do BaseSegmentedTabs.
export const comunicacoesSubNavOptions = (can) =>
  visibleChannels(can).map((channel) => ({
    value: channel.key,
    text: channel.label,
  }))

// Rota ativa -> key do canal. Usa prefixo pra cobrir as sub-rotas de Transcrições.
export const comunicacoesSubNavActive = (routeName) => {
  const found = COMUNICACOES_CHANNELS.find(
    (channel) => routeName && routeName.indexOf(channel.routeName) === 0
  )
  return found ? found.key : COMUNICACOES_CHANNELS[0].key
}

export const comunicacoesSubNavRouteName = (key) => {
  const found = COMUNICACOES_CHANNELS.find((channel) => channel.key === key)
  return found ? found.routeName : null
}

// Primeiro canal visível — alimenta o redirect dinâmico de crm.comunicacoes.
export const comunicacoesFirstVisible = (can) => {
  const [first] = visibleChannels(can)
  return first ? first.routeName : null
}

// Substantivo em prosa de cada canal — só pro subtítulo da aba de topo.
const SUBTITLE_NOUN = {
  atendimento: 'mensagens',
  email: 'e-mails',
  transcricoes: 'transcrições',
  ligacoes: 'ligações',
}

// Subtítulo da aba de topo — menciona só os canais habilitados pro escritório.
export const comunicacoesSubtitle = (can) => {
  const nouns = visibleChannels(can).map((channel) => SUBTITLE_NOUN[channel.key])
  const phrase =
    nouns.length === 1
      ? nouns[0]
      : `${nouns.slice(0, -1).join(', ')} e ${nouns[nouns.length - 1]}`
  return `${phrase.charAt(0).toUpperCase()}${phrase.slice(1)} em um só lugar`
}
